<template>
  <div class="ct-legacy-test-form">
    <DynamicTestForm
      ref="form"
      :test-value="testValue"
      :previous-answer="initialAnswers || {}"
      @corrected="$emit('corrected', $event)"
    />
  </div>
</template>

<script>
import DynamicTestForm from "@/components/botpie-assistant/DynamicTestForm.vue";
import { getTestByValue } from "../constants/testCatalog";

// Los componentes de form-test/ no comparten un nombre para el método que
// envía la corrección; estos son todos los que se usan hoy.
const SUBMIT_METHODS = [
  "send_test",
  "sendInitialTest",
  "sendTest",
  "handleSubmit",
];

export default {
  name: "LegacyTestForm",
  components: { DynamicTestForm },
  props: {
    testValue: { type: Number, required: true },
    age: { type: String, default: "" },
    // Mismo nombre que en los forms propios de corregir-test; aquí se traduce
    // al `previous_answer` que esperan los componentes viejos de form-test/,
    // que ya saben hidratarse solos con él.
    initialAnswers: { type: Object, default: null },
  },
  computed: {
    testMeta() {
      return getTestByValue(this.testValue);
    },
    requiresAge() {
      return Boolean(this.testMeta && this.testMeta.requiresAge);
    },
    toolbarLabel() {
      return "Corregir test";
    },
    toolbarDisabled() {
      if (this.requiresAge && !this.age) return true;
      return false;
    },
    loading() {
      return false;
    },
  },
  watch: {
    toolbarLabel: { immediate: true, handler: "emitToolbarMeta" },
    toolbarDisabled: { immediate: true, handler: "emitToolbarMeta" },
    age: {
      immediate: true,
      handler(val) {
        this.syncAgeToForm(val);
        this.emitToolbarMeta();
      },
    },
    testValue() {
      this.$nextTick(() => {
        this.hideInlineAgeField();
        this.syncAgeToForm(this.age);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.hideInlineAgeField();
      this.syncAgeToForm(this.age);
    });
  },
  updated() {
    this.hideInlineAgeField();
  },
  methods: {
    emitToolbarMeta() {
      this.$emit("toolbar-meta", {
        label: this.toolbarLabel,
        disabled: this.toolbarDisabled,
        loading: this.loading,
      });
    },
    getInnerForm() {
      const wrapper = this.$refs.form;
      return wrapper && wrapper.$refs.form ? wrapper.$refs.form : null;
    },
    syncAgeToForm(age) {
      if (!this.requiresAge || !age) return;
      const inner = this.getInnerForm();
      if (!inner || !inner.answer || !inner.answer.answers) return;
      this.$set(inner.answer.answers, "edad", age);
    },
    hideInlineAgeField() {
      if (!this.requiresAge) return;
      const root = this.$el;
      if (!root) return;
      const edadEl = root.querySelector("#edad");
      if (!edadEl) return;
      const group = edadEl.closest(".form-group");
      if (group) group.style.display = "none";
    },
    submit() {
      if (this.toolbarDisabled) {
        if (this.requiresAge && !this.age && this.$toasted) {
          this.$toasted.error("Selecciona la edad antes de corregir.");
        }
        return;
      }
      this.syncAgeToForm(this.age);
      const submitter = this.findSubmitter(this.getInnerForm());
      if (!submitter) {
        if (this.$toasted) {
          this.$toasted.error(
            "No se pudo enviar este test. Recarga la página e intenta de nuevo."
          );
        }
        return;
      }
      submitter.component[submitter.method]();
    },
    // El método de envío no siempre está en el componente raíz del test: los
    // dos Evalúa delegan todo el formulario (y su propio botón "Corregir
    // Test") en GenericTest, así que hay que bajar por el árbol hasta
    // encontrar quién sabe enviar. Se prueba primero el propio componente,
    // que es lo que hacían los tests que ya funcionaban.
    findSubmitter(component) {
      if (!component) return null;
      const method = SUBMIT_METHODS.find(
        (name) => typeof component[name] === "function"
      );
      if (method) return { component, method };
      const children = component.$children || [];
      for (let i = 0; i < children.length; i += 1) {
        const found = this.findSubmitter(children[i]);
        if (found) return found;
      }
      return null;
    },
    reset() {},
  },
};
</script>

<style scoped>
.ct-legacy-test-form ::v-deep .card,
.ct-legacy-test-form ::v-deep .b-card {
  border: none;
  background: transparent;
  box-shadow: none;
}
</style>
